module.exports = __webpack_public_path__ + "img/schedule.0fb796db.svg";